import { push } from 'connected-react-router';
import moment from 'moment';

import api from '../../lib/api';

const createCookie = (name, value, days) => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + ( days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toGMTString()}`;
  }
  document.cookie = `${name}=${value}+${expires}; path=/; domain=livewelldorset.co.uk`;
};

export const processLogin = args =>
  function get(dispatch) {
    dispatch(loginError(''));
    const post = {
      username: args.email,
      password: args.pw,
      dob: args.dob,
    };

    api.proxyPost('/oauth/token', post)
      .then((response) => {
        if (response.data.access_token) {
          const win = document.getElementsByTagName('iframe')[0].contentWindow;

          if (win) {
            /**
             * localStorage.setItem('access_token', res.data.access_token);
             * localStorage.setItem('expires_in', expires);
             * localStorage.setItem('refresh_token', res.data.refresh_token);
             */
            const expires = moment().add(response.data.expires_in, 'seconds');
            // win.postMessage(JSON.stringify({ key: 'access_token', data: response.data.access_token }), '*');
            // win.postMessage(JSON.stringify({ key: 'expires_in', data: expires }), '*');
            // win.postMessage(JSON.stringify({ key: 'refresh_token', data: response.data.refresh_token }), '*');

            // cookiestring
            const cookiestring = [
              response.data.access_token,
              expires,
              response.data.refresh_token,
            ].join('||');

            createCookie('lmw', cookiestring, 3);
          }

          api.setToken(response.data);
          dispatch(loginSuccess(response.data));
          if (!args.noredirect) {
            dispatch(push('/dashboard'));
          }
        } else {
          dispatch(loginError('Sorry those details do not match our records, please try again.'));
        }
      })
      .catch(error => dispatch(loginError('Sorry those details do not match our records, please try again.')));
  };

export const loginSuccess = data => ({
  type: 'LOGIN_SUCCESS',
  data,
});

export const loginError = msg => ({
  type: 'LOGIN_ERROR',
  msg,
});

export const clearLogin = msg => ({
  type: 'CLEAR_LOGIN',
  msg,
});


export const pingLogin = token =>
  function get(dispatch) {
    // do login
    api
      .proxyGet('/me')
      .catch((error) => {
        dispatch(clearLogin());
        dispatch(loginError('Session Timed Out'));
        dispatch(push('/login/'));
      });
  };



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/login.js